import { modifyPageLayoutComponents } from '../PageLayout';
import {
  ProjectScope,
  ProjectScopeContainer,
  ProjectScopePageHeaderContainer,
  ProjectScopePageFooterContainer
} from './ProjectScope';
import ProjectScopeCard from './ProjectScopeCard';

export { ProjectScope, ProjectScopeContainer, ProjectScopeCard };

export const ProjectScopeLayoutComponents = modifyPageLayoutComponents({
  pageHeader: ProjectScopePageHeaderContainer,
  content: ProjectScopeContainer,
  pageFooter: ProjectScopePageFooterContainer
});
